// This file exports the content data from content.json
// Using a .js file ensures better compatibility with Next.js webpack

export const contentData = {
  "aboutMe": "Based in INDIA, he's a Data Science Manager and AI architect with 13+ years in software engineering, now specializing in Generative AI. He has architected production RAG systems spanning 10M+ documents, multi-agent platforms built on LangChain and LangGraph, and durable Temporal-based workflow orchestration for enterprise clients. Grounded in a full-stack foundation across Python, .NET, React, and Node, his end-to-end approach takes AI systems from prototype to production.",
  "design": "Design",
  "designDescription": "With a touch of artistic flair and splash of colors a design becomes a work of art, inviting the user on a journey through its purposeful and visually pleasing elements.",
  "figma": "Figma",
  "illustrator": "Illustrator",
  "webflow": "Webflow",
  "resume": "Resume",
  "projects": "Projects",
  "username": "niisar",
  "usernameFull": "Nisar A.",
  "work": "Work",
  "about": "About",
  "technology": "Tech",
  "webDev": "Web Dev",
  "webDevDescription": "Specialized in building intelligent, user-friendly applications — pairing React-centered frontends with Python AI services. He adds a splash of personality (and lately, a few LLMs) to every project he works on.",
  "nextjs": "NextJs",
  "tailwind": "Tailwind",
  "typescript": "Typescript",
  "experience": "Experience",
  "carrierStartYear": "2013",
  "yearsOfExperience": "Years of Experience",
  "yearsOfExperienceDescription": "During these {year} years in software engineering, he has grown from full-stack development into AI/ML leadership — building production RAG systems, multi-agent applications, computer vision platforms, and durable workflow orchestration. Given are some skill-sets that he has learned and still actively works with.",
  "getInTouch": "Get in touch.",
  "getInTouchDescription": "If you have any queries or would like to discuss potential opportunities, please don't hesitate to reach out to him using given links.",
  "worksLabel": "Works",
  "worksDescription": "It has been an absolute pleasure to put my heart and soul into these projects. While you're here, browse these projects. 💖",
  "developer": "Gamer",
  "designer": "AI Engineer",
  "weeb": "System Architect",
  "contact": "Contact",
  "gmail": "GMail",
  "userGmail": "nisar2048@gmail.com",
  "linkedin": "LinkedIn",
  "instagram": "Instagram",
  "instagramAccount": "@niisark.fig",
  "dattebayo": "nisar",
  "develop": "Develop",
  "anime": "Anime",
  "psychology": "Psychology",
  "techHeaderStack": "Tech Stack",
  "techHeaderDescription": "Just like any other dev, I also spend more time searching and experimenting tools than actually coding some senseful things 😎",
  "techHeaderTitle": "tech ✦ nisar",
  "aboutTitle": "about ✦ nisar",
  "workTitle": "work ✦ nisar",
  "homeTitle": "nisar ✦ Data Science Manager: LLMs, RAG & Agentic AI Systems",
  "shortInformation": "That was a short information about the domain that he has previously worked on. while you're at it, have a look at few chosen works that he have created using above domain. And if you want to know more, you can download his resume",
  "contactTitle": "contact ✦ nisar",
  "name": "Name",
  "email": "Email",
  "message": "Message",
  "submit": "Submit",
  "githubRepo": "Amazing ? ⭐ my Github Repo",
  "thankYouTitle": "thank you ✦ nisar",
  "thankYou": "Thank you!",
  "formSubmissionReceived": "Your form submission has been received.",
  "content": "nisar ✦ data science manager, ai architect",
  "resumeDesignation": "Data Science Manager",
  "resumePersonalInfo": "Personal Info",
  "resumeSkills": "Skills",
  "tech": [
    {
      "id": "10",
      "title": "Python",
      "main": "/icons/python-icon.svg",
      "desc": "His primary language for AI/ML engineering — powering RAG pipelines, agent orchestration, FastAPI services, and large-scale document processing in production.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "11",
      "title": "GenAI",
      "main": "/icons/genai-icon.svg",
      "desc": "Large Language Models in production: RAG architecture, prompt engineering, embeddings and vector search, semantic caching, evaluation, and LLMOps on Azure OpenAI.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "12",
      "title": "LangChain",
      "main": "/icons/langchain-icon.svg",
      "desc": "LLM application framework he pairs with LangGraph to build multi-agent systems — specialized agents, conditional routing, tool calling, and confidence-based verification.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "13",
      "title": "Temporal",
      "main": "/icons/temporal-icon.svg",
      "desc": "Durable workflow orchestration for fault-tolerant, long-running processes — retry policies, signals, and versioned workflows; the same execution patterns that keep agentic AI systems reliable.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "1",
      "title": "DotNET",
      "main": "/icons/dotnet.svg",
      "desc": "Unleash the power of versatility and performance with .NET – your ultimate platform for building dynamic, cross-platform applications.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "2",
      "title": "React",
      "main": "/icons/react-original.svg",
      "desc": "A free and open-source front-end JavaScript library for building user interfaces based on components",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "3",
      "title": "Angular",
      "main": "/icons/angular-icon.svg",
      "desc": "Angular is a platform and framework for building single-page client applications using HTML and TypeScript. Developed by Google.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "4",
      "title": "NodeJS",
      "main": "/icons/nodejs-icon.svg",
      "desc": "Node.js is a powerful, open-source JavaScript runtime environment that allows developers to build server-side and network applications using JavaScript.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "5",
      "title": "Serverless",
      "main": "/icons/serverless-icon.svg",
      "desc": "Serverless computing is a cloud computing execution model where the cloud provider dynamically manages the allocation and provisioning of servers.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "6",
      "title": "SQL",
      "main": "/icons/sql-icon.svg",
      "desc": "SQL (Structured Query Language) is a standardized programming language used for managing and manipulating relational databases.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "7",
      "title": "NoSQL",
      "main": "/icons/db-icon.png",
      "desc": "NoSQL databases are a diverse set of database technologies designed for large-scale data storage and for handling specific data models like key-value, document, column, and graph formats.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "8",
      "title": "JavaScript",
      "main": "/icons/javascript-original.svg",
      "desc": "A lightweight, interpreted, or just-in-time compiled programming language with first-class functions.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    },
    {
      "id": "9",
      "title": "Playwright",
      "main": "/icons/playwright-icon.svg",
      "desc": "Playwright is an open-source automation library for testing and performing tasks in modern web browsers.",
      "tag": "link",
      "bg": "bg-blue-50",
      "text": "text-blue-500"
    }
  ],
  "techSeq": "10,11,12,13,1,2,3,4,5,6,7,8,9",
  "works": [
    {
      "id": 9,
      "image": "ragPlatform",
      "title": "RAG Platform",
      "description": "Enterprise Generative AI platform with hybrid RAG over 10M+ documents and specialized multi-agent orchestration for legal, financial, and support domains.",
      "link": "/work/work9",
      "linkTitle": "RAG Platform ✦ work",
      "linkSubheading": "Generative AI Platform",
      "liveLink": "",
      "codeLink": "",
      "mainContent": "<div>An enterprise Generative AI platform built to answer questions over a corpus of 10M+ documents across multiple customer domains, each mapped to its own embedding store with RBAC-based access control. The system combines retrieval-augmented generation with a multi-agent framework so that every query is routed to the agent best equipped to answer it.</div><br><h2>Key Features:</h2><ol><li><strong>Hybrid RAG Architecture</strong>: Hierarchical retrieval with document-level and chunk-level indexes, hybrid search (70% vector + 30% keyword) on Azure AI Search, and cross-encoder reranking using ms-marco-MiniLM.<li><strong>Multi-Agent Orchestration</strong>: A coordinator agent built with LangGraph routes requests to specialized Legal, Financial, and Support agents, each connected to domain-specific indexes with conditional routing and confidence-based verification.<li><strong>Semantic Caching</strong>: Redis-backed semantic cache at a 0.95 similarity threshold, delivering a 3x latency improvement and 40% LLM cost reduction.<li><strong>Data Ingestion Pipeline</strong>: Azure Data Factory and Azure Functions process 100K+ documents daily with classification, OCR (Tesseract), intelligent chunking, dead-letter queues, and checkpointing.<li><strong>LLMOps</strong>: Prompt versioning, A/B testing, monitoring, and cost optimization practices established across the platform.</ol><h2>Technical Stack:</h2><ul><li><strong>AI</strong>: Azure OpenAI (GPT-4, text-embedding-ada-002), LangChain, LangGraph<li><strong>Retrieval</strong>: Azure AI Search, Redis semantic cache<li><strong>Pipeline</strong>: Azure Data Factory, Azure Functions, Python<li><strong>Infrastructure</strong>: Docker, Kubernetes</ul><p><strong>Outcome</strong>:<br>3x latency improvement through semantic caching, 40% LLM cost reduction, 85% first-response resolution in conversational AI, and 100K+ documents processed daily.</p>"
    },
    {
      "id": 10,
      "image": "yogly",
      "title": "Yogly",
      "description": "AI-powered yoga platform with real-time pose detection across 84 poses at sub-100ms latency, NLP-driven coaching, and ML-powered analytics.",
      "link": "https://yogly.ai",
      "linkTitle": "Yogly ✦ work",
      "linkSubheading": "AI-Powered Yoga Platform",
      "liveLink": "https://yogly.ai",
      "codeLink": "",
      "mainContent": "<div>Yogly is an AI-powered yoga platform featuring real-time pose detection, personalized feedback, and comprehensive analytics. A MediaPipe-based computer vision pipeline evaluates 84 yoga poses at 98% accuracy with sub-100ms latency, while an NLP-powered feedback system delivers personalized coaching recommendations.</div><br><div>The Yoglytics dashboard tracks progress and trends with ML-driven insights, and the platform's subscription system serves 10K+ users. Built with React (TypeScript), Node.js, and PostgreSQL, with end-to-end testing in Playwright and Cucumber at 80% coverage.</div>"
    },
    {
      "id": 8,
      "image": "learnosity",
      "title": "Learnosity Tools",
      "description": "AI-driven assessment content generation — intelligent MCQ upcycling and content analysis using NLP and LLM techniques for enhanced learning.",
      "link": "",
      "linkTitle": "Learnosity Tools ✦ work",
      "linkSubheading": "AI Assessment Content",
      "liveLink": "",
      "codeLink": "",
      "mainContent": "<div>An AI-powered assessment content system built on the Learnosity platform, using NLP and LLM techniques to analyze existing learning content and intelligently upcycle it into new multiple-choice questions and interactive assessment items.</div><br><div>The system performs content analysis and optimization to keep question banks fresh and pedagogically sound, dramatically reducing the manual effort of authoring assessment content. This work was recognized by Learnosity with the AI-Powered Education Innovator of the Year award (2024).</div>"
    },
    {
      "id": 1,
      "image": "connectPlus",
      "title": "Connect Plus",
      "description": "Connect Plus is an Relocation and Logistic Management Software which runs in browser as well as Mobile.",
      "link": "",
      "linkTitle": "Connect Plus ✦ work",
      "linkSubheading": "Relocation & Logistics",
      "liveLink": "",
      "codeLink": "",
      "mainContent": "The Appointment Reminder system is a robust application designed to automate the process of reminding users about their upcoming appointments via SMS notifications. By integrating advanced scheduling and messaging techniques, this application ensures that users are kept abreast of their scheduled activities, leading to reduced no-shows and better time management.<h2>Key Features:</h2><ol><li><strong>Automated SMS Reminders</strong>: Prior to the set appointment time, users receive timely SMS notifications to remind them of their commitments.<li><strong>Azure TimeTrigger Function</strong>: Utilized for precision scheduling, this feature ensures that reminders are sent out at the exact predetermined intervals.<li><strong>Orchestrator Function</strong>: Orchestrates the overall workflow, guaranteeing that each component of the application runs seamlessly and in harmony.<li><strong>Keyvault Canary Testing</strong>: For security and continuous testing purposes, the Azure Keyvault is employed. It ensures safe storage of secrets and is integrated with canary testing for continuous monitoring and validation.<li><strong>Subevents Queues</strong>: These queues efficiently handle all the sub-tasks and events required in the process of sending out reminders. They ensure that no task is missed and the reminders are sent out without any hitches.<li><strong>Reporting Tools</strong>: The system provides comprehensive reports on imported applications and reminders sent. This aids in tracking the efficiency and effectiveness of the reminder process.<li><strong>ReactJS Interface</strong>: The user interface, designed in ReactJS, offers a responsive and intuitive dashboard where users can track their appointment reminders and view reports.</ol><h2>Technical Stack:</h2><ul><li><strong>Backend</strong>: Developed using C# and .NET, ensuring a strong, secure, and scalable backend.<li><strong>Frontend</strong>: Leveraged ReactJS for a dynamic and user-friendly frontend.<li><strong>Cloud & Services</strong>: Extensively used Azure services, including functions like TimeTrigger and Orchestrator Function for optimal performance.</ul><p><strong>Outcome</strong>:<br>The Appointment Reminder system successfully streamlines the process of reminding users about their commitments. By automating this crucial task, the system ensures that users are always informed in a timely manner, leading to enhanced user satisfaction and reduced operational hiccups."
    },
    {
      "id": 2,
      "image": "pearlyPlan",
      "title": "Pearly Plan",
      "description": "Pearly is a membership program solution to launch, manage, and grow in-house dental membership program.",
      "link": "",
      "linkTitle": "Pearly Plan ✦ work",
      "linkSubheading": "Dental Membership SaaS",
      "liveLink": "",
      "codeLink": "",
      "mainContent": "<div>Pearly Plan is a comprehensive membership program solution for dental practices, enabling them to launch, manage, and grow in-house membership programs that enhance patient loyalty and create predictable recurring revenue.</div><br><div>The platform features automated recurring billing with configurable schedules and prorated charges, PayPal and Clearent payment gateway integration with failure handling, a React (TypeScript) admin portal for managing plans and enrollments, and a patient portal secured with Google Identity. A reporting dashboard tracks retention and revenue, and the whole system is built HIPAA-compliant on a GraphQL API with Node.js and PostgreSQL.</div>"
    },
    {
      "id": 3,
      "image": "dsoCompliance",
      "title": "DSO Compliance",
      "description": "SAAS based solution for Dental Support (or Service) Organization.",
      "link": "",
      "linkTitle": "DSO Compliance ✦ work",
      "linkSubheading": "Healthcare Compliance SAAS",
      "liveLink": "",
      "codeLink": "",
      "mainContent": "<div>DSO Compliance is a healthcare compliance SAAS solution tailored for Dental Service Organizations, helping them maintain regulatory compliance with automated workflows and reporting.</div><br><div>The platform is built on .NET Core microservices with SQL Server and an Angular (TypeScript) frontend featuring role-based access control. An automated workflow engine powered by Hangfire drives audits, reminders, and escalations, while a regulatory reporting module covers OSHA, HIPAA, and state-specific regulations. Document management with version control and audit trails keeps every compliance artifact traceable.</div>"
    },
    {
      "id": 4,
      "image": "interphase",
      "title": "INTERPHASE",
      "description": "A Dashboard for Dental Healthcare to help eliminate no-shows, Improves patient communication, transparency of accounts, day-to-day reports.",
      "link": "",
      "linkTitle": "INTERPHASE ✦ work",
      "linkSubheading": "Dental Healthcare Dashboard",
      "liveLink": "",
      "codeLink": "",
      "mainContent": "<div>INTERPHASE is a comprehensive dental healthcare dashboard that improves practice-patient communication, account transparency, and day-to-day operational efficiency in dental practices.</div><br><div>It provides a React (TypeScript) patient portal for appointment booking and secure messaging, real-time notifications for reminders and updates, and an operational analytics dashboard tracking appointment utilization, revenue, and satisfaction. The system integrates with major practice management systems — Dentrix, Open Dental, and EagleSoft — over a GraphQL API with Node.js and PostgreSQL, with HIPAA-compliant communication throughout.</div>"
    },
    {
      "id": 5,
      "image": "aps",
      "title": "APS",
      "description": "Advertisement Production System is a CMS for the SB-Media to manage the Digital assets, Design Brochures and manage the life cycle of a marketing campaign.",
      "link": "",
      "linkTitle": "APS ✦ work",
      "linkSubheading": "Advertising Production CMS",
      "liveLink": "",
      "codeLink": "",
      "mainContent": "<div>The Advertisement Production System (APS) is a content management solution built for SB-Media to manage product information, digital assets, brochure design, and the full life cycle of marketing campaigns.</div><br><div>It features digital asset management with upload, categorization, versioning, and search; product information management; campaign lifecycle tracking; and automated brochure generation from templates. The system is built with an Angular (TypeScript) interface for marketing teams over a .NET Core backend with RESTful APIs and MongoDB, with role-based permissions throughout.</div>"
    },
    {
      "id": 6,
      "image": "rfp",
      "title": "RFP",
      "description": "Request For Proposal is a bidding process automation for procurement of a commodity, service or valuable asset. It is a bidding process workflow automation.",
      "link": "",
      "linkTitle": "RFP ✦ work",
      "linkSubheading": "Procurement Automation",
      "liveLink": "",
      "codeLink": "",
      "mainContent": "<div>The RFP system automates the bidding process for procurement of commodities, services, and assets, replacing manual workflows with automated routing through approval chains and vendor selection.</div><br><div>Built with AngularJS on SharePoint and Office 365, it provides document management for templates, proposals, and contracts; a vendor portal for viewing opportunities and submitting proposals; and an evaluation module with a scoring system and reporting dashboard for transparent, auditable procurement decisions.</div>"
    },
    {
      "id": 7,
      "image": "inventorySystem",
      "title": "Inventory System",
      "description": "An ERP and POS system for local wholesale business. Features include Day Checkin/Checkout, Account Management, Inventories Management and Financial Profit and Loss Reports, Ledger and Bookkeeping.",
      "link": "",
      "linkTitle": "Inventory System ✦ work",
      "linkSubheading": "ERP & POS System",
      "liveLink": "",
      "codeLink": "",
      "mainContent": "<div>A comprehensive ERP and POS system for wholesale business operations, covering day check-in/checkout with cash reconciliation, point-of-sale invoicing, account management, and inventory management with stock tracking, reorder alerts, and expiry monitoring.</div><br><div>Financial reporting is powered by SAP Crystal Reports for profit/loss and sales analysis, alongside ledger and bookkeeping modules. Built as a Windows GUI application on .NET with a MySQL database, the system manages the complete day-to-day operations of the business.</div>"
    }
  ]
};
